import React from "react";

import {
  Phone,
  MessagesSquare,
  CreditCard,
  CheckCircle2,
  ChevronRight,
} from "lucide-react";

import "./Quytrinh.css";

const Quytrinh = () => {
  const steps = [
    {
      number: "1",
      icon: Phone,
      title: "Liên hệ",
      description: "Cung cấp số tiền muốn rút",
    },
    {
      number: "2",
      icon: MessagesSquare,
      title: "Nhận báo phí",
      description: "Nhân viên tư vấn báo phí chính xác",
    },
    {
      number: "3",
      icon: CreditCard,
      title: "Xác nhận & thực hiện",
      description: "Tiến hành giao dịch an toàn, nhanh chóng",
    },
    {
      number: "4",
      icon: CheckCircle2,
      title: "Nhận tiền",
      description: "Hoàn tất và nhận tiền sau 3 phút",
    },
  ];

  return (
    <section className="process-section">
      <div className="process-container">
        {/* SECTION HEADING */}

        <div className="process-heading">
          <h2>QUY TRÌNH RÚT TIỀN ĐƠN GIẢN</h2>

          <p>Chỉ 4 bước - Nhận tiền nhanh chóng</p>
        </div>

        {/* PROCESS STEPS */}

        <div className="process-grid">
          {steps.map((step, index) => {
            const Icon = step.icon;

            return (
              <React.Fragment key={step.number}>
                <div className="process-step">
                  {/* ICON */}

                  <div className="process-icon">
                    <Icon size={30} strokeWidth={2.5} />
                  </div>

                  {/* STEP TITLE */}

                  <div className="process-step-heading">
                    <span className="process-number">{step.number}</span>

                    <h3>{step.title}</h3>
                  </div>

                  {/* DESCRIPTION */}

                  <p className="process-description">{step.description}</p>
                </div>

                {/* ARROW BETWEEN STEPS */}

                {index < steps.length - 1 && (
                  <div className="process-arrow">
                    <ChevronRight size={24} strokeWidth={2} />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Quytrinh;
